import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpHeaders,HttpResponse,HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { NonQuery, DataTable, Session,User } from '../models/data.types';
import { environment } from '../../environments/environment'

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { tokenKey } from '@angular/core/src/view/util';

@Injectable()
export class ApiService {

    isLoggedIn: boolean = false;
    roles: string[];
    redirectUrl: string;
    headers: HttpHeaders;
    authHeaders: HttpHeaders;
    tokenHeaders: HttpHeaders;
    apiUrl: string;
    baseUrl: string;
    tokenUrl: string;
    adTokenUrl: string;
    session: Session;
    userName: string;

    constructor(private http: HttpClient, private router: Router) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.tokenHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        this.baseUrl = environment.apiUrl;
        this.apiUrl = `${this.baseUrl}service/api/`;
        this.tokenUrl = `${this.baseUrl}service/token`;
        this.adTokenUrl = `${this.baseUrl}service/api/Account/AdLogin`;
    }

    login(userName: string, passWord: string): Promise<Session> {
        let tokenRequest = 'grant_type=password&username=' + userName + '&password=' + encodeURIComponent(passWord);


        return this.http.post(
            this.tokenUrl,
            tokenRequest, {
                headers: this.tokenHeaders
            })
            .toPromise()
            .then(x => {
                this.isLoggedIn = true;
                return x;
            })
            .catch(x => x);
    }

    adLogin(userName: string, passWord: string): Promise<Session> {
        let tokenRequest = 'username=' + userName + '&password=' +encodeURIComponent(passWord);
        return this.http.post(
            this.adTokenUrl,
            tokenRequest, {
                headers: this.tokenHeaders
            })
            .toPromise()
            .then(x => {
                this.isLoggedIn = true;
                return x;
            })
            .catch(x => x);
    }

    userLogin(userName: string, passWord: string){
        let tokenRequest = 'grant_type=password&username=' + userName + '&password=' + passWord;
        return this.http.post(
            this.tokenUrl,
            tokenRequest, {
                headers: this.tokenHeaders
            })
            .map(x => {
                localStorage.setItem('session', JSON.stringify(x));
                let session = JSON.parse(JSON.stringify(x));

                let user : User = new User();
                user.username = userName;
                user.password = passWord;
                user.token = JSON.parse(session._body).access_token.toString();
                localStorage.setItem('currentUser', JSON.stringify(user));
                
                this.isLoggedIn = true;
                return x;
            })
            .catch(x => x);
    }

    public logout() {
        return this.http.post(this.apiUrl + 'account/logout', {}, { headers: this.authHeaders })
            .map((response: Response) => {
                localStorage.clear();
                return true;
            })
            .catch((err: Response) => { return Observable.throw(err.json) });
    }

    get<T>(url: string): Promise<T> {
        return this.http.get(this.apiUrl + url, { headers: this.authHeaders }).toPromise().then(x => x as T).catch(this.handleError);
    }

    put(url: string, o: any) {
        this.http.put(this.apiUrl + url, o, { headers: this.authHeaders }).toPromise().catch(this.handleError);
    }

    putAs<T>(url: string, o: any): Promise<T> {
        return this.http.put(this.apiUrl + url, o, { headers: this.authHeaders }).toPromise().then(x => x as T).catch(this.handleError);
    }

    post(url: string, o: any) {
        this.http.post(this.apiUrl + url, o, { headers: this.authHeaders }).toPromise().catch(this.handleError);
    }

    postAs<T>(url: string, o: any): Promise<T> {
        return this.http.post(this.apiUrl + url, o, { headers: this.authHeaders }).toPromise().then(x => x as T).catch(this.handleError);
    }

    delete<T>(url: string): Promise<T> {
        return this.http.delete(this.apiUrl + url, { headers: this.authHeaders }).toPromise().then(x => x as T).catch(this.handleError);
    }

    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/api.service.ts